import { render, staticRenderFns } from "./StartupPartnershipsModal.vue?vue&type=template&id=37982128&scoped=true&"
import script from "./StartupPartnershipsModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./StartupPartnershipsModal.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37982128",
  null
  
)

export default component.exports